<template>
  <div
    class="tw:flex-col tw:flex tw:w-full tw:md:max-w-screen-lg tw:lg:max-w-screen-xl tw:mr-auto tw:ml-auto tw:min-h-screen-minus-header-and-footer"
  >
    <div class="tw:mt-[40px]">
      <div class="tw:flex tw:items-center tw:py-2">
        <VisitorsProfileIcon class="tw:mr-1" />
        <h4 class="tw:text-xl tw:font-bold">{{ $t('app.visitorsProfile.name') }}</h4>
        <UiTooltip tooltip-position="top" :label="$t('vp_tooltip')" class="tw:cursor-pointer tw:ml-1">
          <InformationOutline class="tw:fill-none tw:stroke-gray-800 tw:h-[22px] tw:w-[22px] tw:ml-1" />
        </UiTooltip>
      </div>
      <p class="tw:flex tw:w-full tw:text-base tw:font-normal">
        {{ $t('vp_tag_line') }}
      </p>
    </div>
    <LaunchpadLoader v-if="isAuthLoading" class="tw:w-full tw:flex tw:justify-center tw:items-center tw:flex-1" />
    <div v-else-if="isError" class="tw:flex tw:justify-center tw:items-center tw:flex-1">
      <ErrorModal
        :allow-retry="false"
        app-name="Visitors Profile"
        :use-app-name="true"
        header-key="onboarding.appLaunchError.header"
        content-key="onboarding.appLaunchError.text"
        retry-key="onboarding.appLaunchError.retryButton"
      />
    </div>
    <div
      v-else
      class="tw:flex-col tw:flex tw:w-full tw:md:max-w-(--tw-breakpoint-lg) tw:lg:max-w-(--tw-breakpoint-xl) tw:mr-auto tw:ml-auto tw:my-9"
    >
      <AppMenuNew :menuItems="menuItems" class="tw:mb-4" />
      <router-view :key="selectedAccommodationId" />
    </div>
  </div>
</template>

<script setup>
/**
 * Visitors Profile Layout Component
 *
 * Access control (Plus subscription check) handled by route meta:
 *   meta: { requires: { hasStudioPlus: true } }
 */
import AppMenuNew from '@/components/appMenu/AppMenuNew.vue'
import LaunchpadLoader from '@/components/dashboard/common/LaunchpadLoader.vue'
import ErrorModal from '@/components/dashboard/ErrorModal.vue'
import InformationOutline from '@/components/icons/InformationOutline.svg?component'
import UiTooltip from '@/components/dashboard/ui/UiTooltip.vue'
import VisitorsProfileIcon from '@/components/icons/VisitorsProfileIcon.svg?component'
import { selectedAccommodationId } from '@/layouts/queries'
import { useStudioPlusAuth } from '@/composables/useStudioPlusAuth'

const { isAuthLoading, isError } = useStudioPlusAuth()

const menuItems = [
  { label: 'vp_stay_header', route: '/visitors-profile/stay-duration', testId: 'visitors-profile-stay-duration' },
  { label: 'vp_time_header', route: '/visitors-profile/search-window', testId: 'visitors-profile-search-window' },
  {
    label: 'vp_countries_header',
    route: '/visitors-profile/search-countries',
    testId: 'visitors-profile-search-countries',
  },
]
</script>
